'use client';

import Image from 'next/image';
import Link from 'next/link';
import classes from './Footer.module.scss';
import { IconBrandFacebook, IconBrandInstagram } from '@tabler/icons-react';
import { ActionIcon, Container, Group, Text } from '@mantine/core';
import { useDictionary } from '@/src/dictionaries/dictionary-provider';

export function Footer() {
  const dictionary: any = useDictionary();

  // @ts-ignore
  const groups = dictionary.footer.links.map((group) => {
    // @ts-ignore
    const links = group.links.map((link, index) => (
      <Link key={index} className={classes.link} href={link.link}>
        {link.label}
      </Link>
    ));

    return (
      <div className={classes.wrapper} key={group.title}>
        <Text className={classes.title}>{group.title}</Text>
        {links}
      </div>
    );
  });

  return (
    <footer className={classes.footer}>
      <Container className={classes.inner}>
        <div className={classes.logo}>
          <Group>
            <Image alt="logo" src={dictionary.logoUrl} width={75} height={75} />
            <Text>Gallery Joseph</Text>
          </Group>
          <Text size="sm" className={classes.description}>
            {dictionary.footer.description}
          </Text>
        </div>
        <div className={classes.groups}>{groups}</div>
      </Container>
      <Container className={classes.afterFooter}>
        <Text size="sm">
          <Link href="https://hestia-innovation.com" className={classes.link}>
            Développement du site internet: Hestia Innovation
          </Link>
          {dictionary.footer.copyright}
        </Text>

        <Group gap={0} className={classes.social} justify="flex-end" wrap="nowrap">
          <ActionIcon
            size="lg"
            color="gray"
            variant="subtle"
            component={Link}
            href={dictionary.footer.facebook}
            aria-label="Facebook"
            title="Facebook"
          >
            <IconBrandFacebook size={18} stroke={1.5} />
          </ActionIcon>
          <ActionIcon
            size="lg"
            color="gray"
            variant="subtle"
            component={Link}
            href={dictionary.footer.instagram}
            aria-label="Instagram"
            title="Instagram"
          >
            <IconBrandInstagram size={18} stroke={1.5} />
          </ActionIcon>
        </Group>
      </Container>
    </footer>
  );
}
